import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import { useEffect } from "react";

import { AlarmProvider } from "./context/AlarmContext";
import { WellProvider } from "./context/WellContext";
import { AirCoolerProvider } from "./context/AirCoolerContext";
import { PumpProvider } from "./context/PumpContext";
import { TransformerProvider } from "./context/TransformerContext";
import { TrendProvider } from "./context/TrendContext";
import { PigProvider } from "./components/PigEngine";
import PinnedTransmittersLayer from "./components/PinnedTransmittersLayer";
import { CompressorProvider } from "./context/CompressorContext";

import TopBar from "./layout/TopBar";
import BottomNav from "./layout/BottomNav";

/* ================= HOME PAGE ================= */
import HomePage from "./pages/HomePage";

/* ================= EXISTING PAGES ================= */
import WellComp from "./pages/WellComp";
import NK1Wellhead from "./pages/NK1Wellhead";
import NK2Wellhead from "./pages/NK2Wellhead";
import NK3Wellhead from "./pages/NK3Wellhead";
import H2OInjectionWellhead from "./pages/H2OInjectionWellhead";
import GasLiftManifold from "./pages/GasLiftManifold";
import TestHeader from "./pages/TestHeader";
import ProductionHeader1 from "./pages/ProductionHeader1";
import ProductionHeader2 from "./pages/ProductionHeader2";
import PigLauncher from "./pages/PigLauncher";
import PigReceiver from "./pages/PigReceiver";
import TestSeparator from "./pages/TestSeparator";
import FirstStageSeparator from "./pages/FirstStageSeparator";
import SecondStageSeparator from "./pages/SecondStageSeparator";
import ThirdStageSeparator from "./pages/ThirdStageSeparator";
import SludgeCatcher from "./pages/SludgeCatcher";
import CrudeDehyd from "./pages/CrudeDehyd";
import CrudeExport from "./pages/CrudeExport";
import LPCompSuctDrumA from "./pages/LPCompSuctDrumA";
import LPCompSuctDrumB from "./pages/LPCompSuctDrumB";
import MPCompSuctDrumA from "./pages/MPCompSuctDrumA";
import MPCompSuctDrumB from "./pages/MPCompSuctDrumB";
import HPGasInlet from "./pages/HPGasInlet";
import HPGasCooler from "./pages/HPGasCooler";
import GasSweetening from "./pages/GasSweetening";
import PreDehydCooler from "./pages/PreDehydCooler";
import TEGContactor from "./pages/TEGContactor";
import TEGReboiler from "./pages/TEGReboiler";
import GasExportComp from "./pages/GasExportComp";
import GasExport from "./pages/GasExport";
import DeOiler from "./pages/DeOiler";
import H2SStripper from "./pages/H2SStripper";
import SkimPile from "./pages/SkimPile";
import SubseaSettlementTank from "./pages/SubseaSettlementTank";
import OilyWaterTank from "./pages/OilyWaterTank";
import WaterTreatment from "./pages/WaterTreatment";
import VacuumDearator from "./pages/VacuumDearator";
import Na2HydroGen from "./pages/Na2HydroGen";
import CorrosionInhibition from "./pages/CorrosionInhibition";
import Flare from "./pages/Flare";

/* ===================================================== */

function Layout() {
  const location = useLocation();

  /* ================= PAGE PROTECTION ================= */

  useEffect(() => {
    const handleZoom = (e) => {
      if (
        (e.ctrlKey &&
          (e.key === "+" ||
            e.key === "-" ||
            e.key === "=")) ||
        (e.ctrlKey && e.type === "wheel")
      ) {
        e.preventDefault();
      }
    };

    window.addEventListener(
      "keydown",
      handleZoom
    );

    window.addEventListener(
      "wheel",
      handleZoom,
      { passive: false }
    );

    return () => {
      window.removeEventListener(
        "keydown",
        handleZoom
      );

      window.removeEventListener(
        "wheel",
        handleZoom
      );
    };
  }, []);

  useEffect(() => {
    const disableRightClick = (e) =>
      e.preventDefault();

    window.addEventListener(
      "contextmenu",
      disableRightClick
    );

    return () =>
      window.removeEventListener(
        "contextmenu",
        disableRightClick
      );
  }, []);

  useEffect(() => {
    const blockKeys = (e) => {
      if (
        e.key === "F12" ||
        (e.ctrlKey &&
          e.shiftKey &&
          e.key === "I") ||
        (e.ctrlKey &&
          e.shiftKey &&
          e.key === "J") ||
        (e.ctrlKey && e.key === "U")
      ) {
        e.preventDefault();
      }
    };

    window.addEventListener(
      "keydown",
      blockKeys
    );

    return () =>
      window.removeEventListener(
        "keydown",
        blockKeys
      );
  }, []);

  /* ================= HOME PAGE MODE ================= */

  const isHome =
    location.pathname === "/";

  /* ================= TITLE ================= */

  let title = "NK Tech DCS";

  /* ================= RETURN ================= */

  return (
    <>
      {/* Hide TopBar on HomePage */}
      {!isHome && (
        <TopBar title={title} />
      )}

      <div
        style={{
          paddingTop: isHome
            ? "0px"
            : "60px",
          paddingBottom: isHome
            ? "0px"
            : "200px",
        }}
      >
        <Routes>
          {/* HOME PAGE */}
          <Route
            path="/"
            element={<HomePage />}
          />

          {/* EXISTING PAGES */}
          <Route
            path="/WellComp"
            element={<WellComp />}
          />

          <Route
            path="/nk1"
            element={<NK1Wellhead />}
          />

          <Route
            path="/nk2"
            element={<NK2Wellhead />}
          />

          <Route
            path="/nk3"
            element={<NK3Wellhead />}
          />

          <Route
            path="/H2OInjectionWellhead"
            element={
              <H2OInjectionWellhead />
            }
          />

          <Route
            path="/GasLiftManifold"
            element={
              <GasLiftManifold />
            }
          />

          <Route
            path="/TestHeader"
            element={<TestHeader />}
          />

          <Route
            path="/ProductionHeader1"
            element={
              <ProductionHeader1 />
            }
          />

          <Route
            path="/ProductionHeader2"
            element={
              <ProductionHeader2 />
            }
          />

          <Route
            path="/PigLauncher"
            element={<PigLauncher />}
          />

          <Route
            path="/PigReceiver"
            element={<PigReceiver />}
          />

          <Route
            path="/TestSeparator"
            element={
              <TestSeparator />
            }
          />

          <Route
            path="/FirstStageSeparator"
            element={
              <FirstStageSeparator />
            }
          />

          <Route
            path="/SecondStageSeparator"
            element={
              <SecondStageSeparator />
            }
          />

          <Route
            path="/ThirdStageSeparator"
            element={
              <ThirdStageSeparator />
            }
          />

          <Route
            path="/SludgeCatcher"
            element={
              <SludgeCatcher />
            }
          />

          <Route
            path="/CrudeDehyd"
            element={<CrudeDehyd />}
          />

          <Route
            path="/CrudeExport"
            element={
              <CrudeExport />
            }
          />

          <Route
            path="/LPCompSuctDrumA"
            element={
              <LPCompSuctDrumA />
            }
          />

          <Route
            path="/LPCompSuctDrumB"
            element={
              <LPCompSuctDrumB />
            }
          />

          <Route
            path="/MPCompSuctDrumA"
            element={
              <MPCompSuctDrumA />
            }
          />

          <Route
            path="/MPCompSuctDrumB"
            element={
              <MPCompSuctDrumB />
            }
          />

          <Route
            path="/HPGasInlet"
            element={
              <HPGasInlet />
            }
          />

          <Route
            path="/HPGasCooler"
            element={
              <HPGasCooler />
            }
          />

          <Route
            path="/GasSweetening"
            element={
              <GasSweetening />
            }
          />

          <Route
            path="/PreDehydCooler"
            element={
              <PreDehydCooler />
            }
          />

          <Route
            path="/TEGContactor"
            element={
              <TEGContactor />
            }
          />

          <Route
            path="/TEGReboiler"
            element={
              <TEGReboiler />
            }
          />

          <Route
            path="/GasExportComp"
            element={
              <GasExportComp />
            }
          />

          <Route
            path="/GasExport"
            element={<GasExport />}
          />

          <Route
            path="/DeOiler"
            element={<DeOiler />}
          />

          <Route
            path="/H2SStripper"
            element={
              <H2SStripper />
            }
          />

          <Route
            path="/SkimPile"
            element={<SkimPile />}
          />

          <Route
            path="/SubseaSettlementTank"
            element={
              <SubseaSettlementTank />
            }
          />

          <Route
            path="/OilyWaterTank"
            element={
              <OilyWaterTank />
            }
          />

          <Route
            path="/WaterTreatment"
            element={
              <WaterTreatment />
            }
          />

          <Route
            path="/VacuumDearator"
            element={
              <VacuumDearator />
            }
          />

          <Route
            path="/Na2HydroGen"
            element={
              <Na2HydroGen />
            }
          />

          <Route
            path="/CorrosionInhibition"
            element={
              <CorrosionInhibition />
            }
          />

          <Route
            path="/Flare"
            element={<Flare />}
          />
        </Routes>
      </div>

      {/* Hide BottomNav on HomePage */}
      {!isHome && <BottomNav />}
    </>
  );
}

function App() {
  return (
    <CompressorProvider>
      <PigProvider>
        <TrendProvider>
          <TransformerProvider>
            <WellProvider>
              <AlarmProvider>
                <AirCoolerProvider>
                  <PumpProvider>
                    <Router basename="/">
                      <Layout />

                      {/* Floating Layer */}
                      <PinnedTransmittersLayer />
                    </Router>
                  </PumpProvider>
                </AirCoolerProvider>
              </AlarmProvider>
            </WellProvider>
          </TransformerProvider>
        </TrendProvider>
      </PigProvider>
    </CompressorProvider>
  );
}

export default App;